import React from "react";

const COLOR_MAP: Record<string, string> = {
  active:      "bg-emerald-100 text-emerald-700",
  inactive:    "bg-red-100     text-red-700",
  draft:       "bg-gray-100    text-gray-600",
  archived:    "bg-slate-100   text-slate-600",
  pending:     "bg-amber-100   text-amber-700",
  completed:   "bg-blue-100    text-blue-700",
  in_progress: "bg-purple-100  text-purple-700",
  High:        "bg-emerald-100 text-emerald-700",
  Moderate:    "bg-amber-100   text-amber-700",
  Low:         "bg-red-100     text-red-700",
  enterprise:  "bg-indigo-100  text-indigo-700",
  pro:         "bg-purple-100  text-purple-700",
  basic:       "bg-gray-100    text-gray-600",
  aptitude:    "bg-blue-100    text-blue-700",
  behavioral:  "bg-violet-100  text-violet-700",
  iq:          "bg-cyan-100    text-cyan-700",
  situational: "bg-orange-100  text-orange-700",
  descriptive: "bg-pink-100    text-pink-700",
  super_admin: "bg-red-100     text-red-700",
  org_admin:   "bg-indigo-100  text-indigo-700",
  candidate:   "bg-teal-100    text-teal-700",
};

interface Props { text: string; className?: string; variant?: string; size?: string; }

const Badge: React.FC<Props> = ({ text, className = "" , variant="" , size=""}) => {
  // Handle undefined or null text
  if (!text) {
    return (
      <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap bg-gray-100 text-gray-600 ${className}`}>
        —
      </span>
    );
  }

  // Safely replace underscores only if text exists
  const displayText = String(text).replace(/_/g, " ");
  
  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap
      ${COLOR_MAP[text] ?? "bg-gray-100 text-gray-600"} ${className}`}>
      {displayText}
    </span>
  );
};

export default Badge;